/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * Kopfbereich
 *
 */

import React from 'react';
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Icon } from "./Icons";
import * as utils from "../../basics/utils";
import * as appActions from "../../store/actions/appActions";
import * as userActions from "../../store/actions/userActions";
import * as syncActions from "../../store/actions/syncActions";
import * as portfolioActions from "../../store/actions/portfolioActions";
import forsales_logo from '../../assets/images/Logo_forsale-s_gray.svg'
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import { AuthActions } from "store/actions";
import { AuthApi } from 'common/api';
import { UserModal, CompanyModal, UserAvatar, CompanyAvatar } from "components/partials";
import { ConfirmModal } from "./ConfirmModal";

class Header extends React.Component {
    state = {
        openUserModal: false,
        openCompanyModal: false,
    }

    constructor(props) {
        super(props);

        this.component = 'Header';
    }

    toggleUserModal = (state) => () => {
        this.setState({ ...this.state, openUserModal: state });
    }

    toggleCompanyModal = (state) => () => {
        this.setState({ ...this.state, openCompanyModal: state });
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { headerHeight, unitHeight, toolbarType, gridEdit, path, appModus, appPreview, filterVisible, currentContainerTitle, iPhone, online } = this.props.app;
        const { loginUser } = this.props.user;
        const { portfolio } = this.props;

        const dialog = utils.getDialogByPath(path);


        const styleText = { color: 'gray', ...utils.getStyleHeight(headerHeight, 1.0, 1.0, 0.25) };

        const size = 0.5;

        // Hintergrundfarbe festlegen
        let bgColor = ['search', 'favored', 'more'].includes(toolbarType) ? 'bg-white' : 'bg-black';
        if (toolbarType === 'portfolios') {
            if (dialog.dialogType === 'groups') bgColor = 'bg-white';;
            if (dialog.dialogType === 'products') bgColor = 'bg-white';;
        }

        // ==========================================================================
        //
        // SUB RENDER
        //
        // ==========================================================================

        const renderDummy = () => {
            return <div className="w-1/3 flex flex-row justify-start items-end px-4" style={styleText}></div>
        }

        const renderLogo = () => {

            const styleLogo = {
                ...utils.getStyleHeight(headerHeight, 2, 2, 2),
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundImage: "url(" + forsales_logo + ")"
            };
            const styleVersion = { color: 'gray', ...utils.getStyleHeight(headerHeight, 2, 1.2, 0.15) };

            const systemLabel = window['cordova'] ? 'iPad' : '';
            const labelVersion = `${process.env.REACT_APP_VERSION} ${systemLabel}`;

            return (
                <div className="w-1/3 flex" >
                    <div className="w-1/3 " style={styleLogo}></div>
                    <div className="w-1/3 flex items-center justify-start" style={styleVersion}>{labelVersion}</div>
                </div>)
        }

        const renderDraft = () => {
            return <div className="w-1/3 flex flex-row justify-end items-end px-4" style={styleText}>Draft-Mode</div>
        }

        const renderCompanyName = () => {
            if (!loginUser || !loginUser.company || !loginUser.company.name) return renderDummy();

            return (
                <div className="w-1/3 px-4" style={{ ...styleText, cursor: "pointer" }} >
                    <div className="flex flex-row items-center gap-2 no-underline hover:no-underline">
                        <Link to="/containers" className="flex items-center" onClick={() => this.props.setToolbarType('containers')}>
                            <Icon type='left' width={unitHeight * .75} height={unitHeight * .75} />
                        </Link>

                        <div onClick={this.toggleCompanyModal(true)}>
                            <CompanyAvatar company={loginUser.company} />
                        </div>
                        <div style={{ whiteSpace: "nowrap" }} onClick={this.toggleCompanyModal(true)}>
                            {loginUser.company.name}
                        </div>
                    </div>
                </div>
            )
        }

        // ###############################################################
        // renderLeft()
        // ###############################################################
        const renderLeft = () => {
            const dialog = utils.getDialogByPath(path);

            const renderInner = (title) => {
                return (
                    <ul className="flex h-full flex-row items-center">
                        <li>
                            <Icon type="left" width={headerHeight * size} height={headerHeight * size} />
                        </li>
                        {!iPhone && (
                            <li>
                                <div>{title ? title : <p>&nbsp;</p>}</div>
                            </li>
                        )}
                    </ul>
                );
            };

            if (toolbarType.toLowerCase() === "admin") {
                if (loginUser && loginUser._role !== 'User') return renderCompanyName();
            }

            if (toolbarType.toLowerCase() === "containers") {
                return renderLogo()
            }

            if (['search', 'favored'].includes(toolbarType)) {
                return (
                    <div className="w-1/3 px-2" style={styleText}>
                        <div
                            className="pr-4 no-underline hover:no-underline"
                            onClick={() => this.props.setToolbarType('portfolios')}>
                            {renderInner(null)}
                        </div>
                    </div>
                )
            }

            if (path === '') {
                if (appModus === 'Admin') {
                    if (['more', 'icons'].includes(toolbarType)) {
                        return (
                            <div className="w-1/3 px-2" style={styleText}>
                                <Link to="/portfolios" className="pr-4 no-underline hover:no-underline" onClick={() => this.props.setToolbarType('portfolios')}>
                                    {renderInner('Portfolios')}
                                </Link>
                            </div>
                        );
                    }
                }

                return (
                    <div className="w-1/3 px-2" style={styleText}>
                        <Link to="/containers" className="pr-4 no-underline hover:no-underline" onClick={() => this.props.setToolbarType('containers')}>
                            {renderInner('Kataloge')}
                        </Link>
                    </div>
                )
            } else {
                if (dialog.dialogType === 'groups' && dialog.groups === '') {
                    return (
                        <div className="w-1/3 px-2" style={styleText} onClick={() => this.props.setPath('')}>
                            {renderInner('Portfolios')}
                        </div>
                    )
                }

                if (dialog.dialogType === 'groups') {
                    return (
                        <div className="w-1/3 px-2" style={styleText} onClick={() => this.props.setPath(dialog.portfolio)}>
                            {renderInner('Portfolios')}
                        </div>
                    )
                }

                return (
                    <div className="w-1/3 px-2" style={styleText} onClick={() => this.props.setPath(dialog.portfolio + '/' + dialog.groups)}>
                        {renderInner(dialog.portfolio)}
                    </div>
                )
            }
        }

        // ###############################################################
        // renderCenter()
        // ###############################################################
        const renderCenter = () => {
            // ###############################################################
            // renderSubTitle / Containertitel anzeigen
            // ---------------------------------------------------------------
            // Schöler Welt
            //
            //
            // ###############################################################
            const renderSubTitle = (title = '') => {
                if (toolbarType === 'containers') return null;

                const style = { color: 'gray', ...utils.getStyleHeight(headerHeight, 0.25, 0.2, 0.22) };

                return (
                    <div className="w-full flex overflow-hidden justify-center">
                        <div className="flex font-normal whitespace-no-wrap" style={style}>
                            {title}
                        </div>
                    </div>
                )
            }

            // ###############################################################
            // renderMainTitle / Status des Containers anzeigen
            // ---------------------------------------------------------------
            // ###############################################################
            const renderMainTitle = () => {
                const titleList = {
                    containers: 'Kataloge',
                    portfolios: 'Portfolios',
                    search: 'Suchen',
                    filter: 'Filter',
                    favored: 'Favoriten',
                    versions: 'Versionen',
                    users: 'Benutzer',
                    sites: 'Websites',
                    icons: 'Icons',
                    admin: 'Admin',
                    sync: 'Sync',
                    more: 'Mehr',
                    login: 'Login',
                    signUp: 'Registrieren',
                }

                let title = titleList[toolbarType];

                // TODO: this is a hack to manually change toolbar title to admin. 
                // https://forsale-s.atlassian.net/browse/FS-124
                if (this.props.history.location.pathname.startsWith("/admin")) {
                    title = "Admin";
                }

                if (toolbarType === 'portfolios') {
                    if (dialog.dialogType === 'groups') title = dialog.portfolio;
                    if (dialog.dialogType === 'products') title = dialog.groups;
                }

                const style = { color: 'gray', ...utils.getStyleHeight(headerHeight, 0.5, 0.5, 0.25) };

                return (
                    <div className="w-full flex overflow-hidden justify-center">
                        <div className="flex whitespace-no-wrap" style={style}>
                            {title}
                        </div>
                    </div>
                )
            }

            // ###############################################################
            // renderCenter()
            // ###############################################################
            //const containerTitle = utils.capitalize(currentContainer);

            return (
                <div className="w-1/3 flex flex-col">
                    {renderSubTitle()}
                    {renderMainTitle()}
                    {renderSubTitle(currentContainerTitle)}
                </div>
            )
        }

        // ###############################################################
        // renderRight()
        // ###############################################################
        const renderRight = () => {

            const renderOnline = () => {
                const style = { color: 'gray', ...utils.getStyleHeight(headerHeight, 0.25, 0.25, 0.15) };
                const styleDot = {
                    width: headerHeight * .1,
                    height: headerHeight * .1,
                };


                let onlineText = online ? 'online' : 'offline';
                let onlineColor = online ? 'bg-green-600' : 'bg-red-600';

                return (
                    <div className="absolute bottom-0 w-full flex overflow-hidden items-center justify-end font-normal">
                        <div className="pr-2" style={style}>{onlineText}</div>
                        <div className={`rounded-full ${onlineColor}`} style={styleDot}></div>
                    </div>
                )
            }

            const renderLogout = () => {

                const onLogout = async () => {
                    // =======================================================
                    // Super wichtig. Alles zurücksetzen, damit nichts von der
                    // vorherigen Session mit einer anderen Benutzerkennung
                    // zurückbleibt. Aber nur wenn man zuvor als Admin
                    // angemeldet war.
                    // =======================================================
                    this.props.resetPortfolio(); // portfolioActions.js

                    this.props.setAppModus('User');

                    this.props.setAppPreview(false);
                    this.props.logoutUser(); // userActions.js

                    await AuthApi.logout();
                    this.props.logout();
                }

                if (loginUser) {

                    if (online) {
                        return (
                            <ExitToAppIcon className="cursor-pointer " fontSize="large" onClick={onLogout} />
                        )
                    }
                }
                return null;
            }

            const renderRole = () => {
                if (!online) return null;
                if (!loginUser) return null;

                if (loginUser._role === 'User') return null;

                return `${loginUser._role}`;
            }

            const renderAvatar = () => {

                if (!online) return null;

                return (
                    <div onClick={this.toggleUserModal(true)}><UserAvatar user={loginUser} /></div>
                )
            }

            const renderLoginToggle = () => {

                if (loginUser) {
                    return (
                        <div className="relative flex w-1/3 pr-4 gap-2 flex-row justify-end items-center cursor-pointer" style={styleText}>
                            <div>{renderRole()}</div>
                            <div>{renderAvatar()}</div>
                            <div>{renderLogout()}</div>
                            {renderOnline()}
                        </div>
                    )
                }
                return null;
            }

            const renderFilter = () => {

                const onClick = () => {
                    if (gridEdit) return;

                    if (filterVisible) {
                        this.props.setToolbarType('portfolios');
                    } else {
                        this.props.setToolbarType('search');
                    }

                    this.props.setFilterVisible(!filterVisible); // appActions.js
                }
                return (
                    <div className="w-1/3 flex justify-end px-2">
                        <div onClick={onClick}>
                            <Icon type="filter" width={headerHeight * size} height={headerHeight * size} />
                        </div>
                    </div>
                )
            }

            // ###############################################################
            // renderRight()
            // ###############################################################

            if (['containers', 'users', 'Admin'].includes(toolbarType)) {
                return renderLoginToggle();
            } else {
                if (appModus === 'Admin') {
                    return renderDraft();
                } else {
                    return renderFilter();
                }
            }
        }

        /**
         * Modaldialog um den GoLive zu bestätigen
         * +---------------------------------------------------+
         * | Draft-Version in Live-Version übernehmen?         |
         * +---------------------------------------------------+
         * | [ABBRUCH]                                  [ OK ] |
         * +---------------------------------------------------+
         */
        const renderGoLiveConfirm = () => {
            const debug = false;

            // #################################################################
            // GoLive wurde bestätigt
            // -----------------------------------------------------------------
            // Wurde der GoLive bestätigt, so werden zunächst mit der Funktion
            // generatePortfolio() die JSON-Dateien für jedes einzelne Portfolio
            // auf dem Server generiert. Danach wird das komplette draft-Verzeichnis
            // in das live-Verzeichnis übernommen.
            // #################################################################
            const onConfirm = () => {
                this.props.generatePortfolio(() => {
                    debug && console.log('VersionsController:generatePortfiolio(success)');

                    this.props.goLivePortfolio(() => {
                        debug && console.log('onGoLiveSuccess()');
                        this.props.closeModalDialog(); // appAction.js
                        this.props.getVersionList(); // versionsAction.js
                    }, () => {
                        debug && console.log('onGoLiveError()');
                        this.props.closeModalDialog(); // appAction.js
                    }); // syncActions.js

                }, () => {
                    console.log('VersionsController:generatePortfiolio(error)');
                }); // portfolioActions.js
            }

            // #################################################################
            // GoLive wurde nicht bestätigt
            // #################################################################
            const onCancel = () => {
                this.props.closeModalDialog();
            }

            // #################################################################
            // renderGoLiveConfirm()
            // #################################################################
            if (portfolio.type.indexOf('PENDING') !== -1) {
                return (
                    <ConfirmModal dialog='ConfirmModal' type='confirmGoLive' title="Bitte warten..." onCancel={onCancel}>
                        <div className="flex justify-start text-2xl font-bold">Version wird veröffentlicht...</div>
                    </ConfirmModal>
                )
            }

            return (
                <ConfirmModal dialog='ConfirmModal' type='confirmGoLive' title="Bestätigung" onConfirm={onConfirm} onCancel={onCancel}>
                    <div className="flex justify-start font-bold text-2xl">Version veröffentlichen?</div>
                </ConfirmModal>
            )
        }

        const renderWorkInProgress = () => {
            if (['containers', 'Admin', 'versions'].includes(toolbarType)) return null;

            const workInProgress = {
                backgroundImage: 'linear-gradient(45deg, #f1b20f 23.68%, #333333 23.68%, #333333 50%, #f1b20f 50%, #f1b20f 73.68%, #333333 73.68%, #333333 100%)',
                backgroundSize: '200px 200px'
            }

            const style = { ...utils.getStyleHeight(unitHeight * 0.4, .4, .4, .4), ...workInProgress };
            if (!appPreview) {
                return <div className="w-full absolute top-0 text-center" style={style}></div>
            }
            return null;
        }

        // ==========================================================================
        //
        // MAIN RENDER
        //
        // ==========================================================================
        const style = utils.getStyleHeight(headerHeight, 1, 1, 1);

        return (
            <>
                <div className="relative w-full" style={style}>
                    {renderWorkInProgress()}
                    <div className={`flex w-full h-full text-center items-center text-gray-200 ${bgColor}`}>
                        {renderLeft()}
                        {renderCenter()}
                        {renderRight()}
                    </div>
                </div>

                <CompanyModal open={this.state.openCompanyModal} onClose={this.toggleCompanyModal(false)} />
                <UserModal open={this.state.openUserModal} onClose={this.toggleUserModal(false)} />

                {renderGoLiveConfirm()}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        sync: state.sync,
        version: state.version,
        portfolio: state.portfolio
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, userActions, syncActions, portfolioActions, AuthActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
